import React, { useCallback } from 'react';
import { useRouteMatch, useParams } from 'react-router-dom';
import ProgrammeView from './programme-view';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { ResourceGetter } from '../../../lib/training-sdk/getter';
import BreadCrumb from '../../common/component/breadcrumbs/breadcrumb';

function ProgrammeLayout({ onBack, ...props }) {

    let { url } = useRouteMatch();
    url = url.endsWith('/') ? url.slice(0, -1) : url;
    const { programme: id } = useParams();

    const dispatch = useDispatch();

    const onClick = useCallback((to, ...args) => {
        dispatch(push(`${url}/${to}`, ...args));
    }, [url]);

    return (

        <ResourceGetter resource='programmes' id={id} render={({ programme }) => (
            <React.Fragment>
                <BreadCrumb handle={id} text={programme && programme.payload && programme.payload.title} link={url} />
                <ProgrammeView {...props} id={id} programme={programme} onBack={onBack} onClick={onClick} url={url} />
            </React.Fragment>
        )} />

    )
}

export default ProgrammeLayout;
